<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Personne à contacter dans l'entreprise</p>
            <p class="no-margin dark-gray text-sm">Toutes les informations de cette section sont obligatoires</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>


  <div *ngIf="isExpanded" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid"
    class="p-20">

    <div>
      <p class="dark-gray no-margin">Nom</p>
      <p class="dark-blue bold">{{contact.name}}</p>
      <!-- <input [(ngModel)]="contact.name" (ngModelChange)="onContactChange()" type="text" name="name"
        id="contact-name" class="w-full text-md dark-blue pap-input" value="{{contact.name}}"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Prénom</p>
      <p class="dark-blue bold">{{contact.firstName}}</p>
      <!-- <input [(ngModel)]="contact.firstName" (ngModelChange)="onContactChange()" type="text" name="firstName"
        id="contact-firstName" class="w-full text-md dark-blue pap-input" value="{{contact.firstName}}"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Fonction dans l'entreprise</p>
      <p class="dark-blue bold">{{contact.occupation}}</p>
      <!-- <input [(ngModel)]="contact.occupation" (ngModelChange)="onContactChange()" type="text" name="occupation"
        id="contact-occupation" class="w-full text-md dark-blue pap-input" value="{{contact.occupation}}"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Numéro de téléphone</p>
      <p class="dark-blue bold">{{contact.phone}}</p>
      <!-- <input [(ngModel)]="contact.phone" (ngModelChange)="onContactChange()" type="text" name="phone"
        id="contact-phone" class="w-full text-md dark-blue pap-input" value="{{contact.phone}}"
        (keypress)="onlyNumbers($event)" pattern="[0-9]*" inputmode="numeric" maxlength="10"> -->
    </div>

    <div>
      <p class="dark-gray no-margin">Adresse courriel</p>
      <p class="dark-blue bold">{{contact.mail}}</p>
      <!-- <input [(ngModel)]="contact.mail" (ngModelChange)="onContactChange()" type="text" name="mail"
        id="contact-mail" class="w-full text-md dark-blue pap-input" value="{{contact.mail}}"> -->
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>